import {IBuilding} from "../../types/IBuilding";
import React, {FunctionComponent, useMemo} from "react";
import ReactMarkdown from "react-markdown";
import StoreApps from "../StoreApps/StoreApps";

import './BuildingFooter.css';
import Banner from "../ui/Banner/Banner";

interface IBuildingFooter {
    building?: IBuilding,
    lang?: string
}

const BuildingFooter: FunctionComponent<IBuildingFooter> = ({building, lang}) => {
    if(!building)
        return null;

    const footerMessage:string|undefined = useMemo(()=>{
        if(!building || !building.footerMessageI18n)
            return undefined;

        const language = lang || building.lang;
        const message = building.footerMessageI18n[language];
        return message ? message.trim() : undefined;
    }, [building, lang]);

    const footerAdvertisement:string|undefined = useMemo(()=>{
        if(!building || !building.footerAdvertisementI18n)
            return undefined;

        const language = lang || building.lang;
        const message = building.footerAdvertisementI18n[language];
        return message ? message.trim() : undefined;
    },[building, lang]);

    return <div className="building-footer">
        {footerMessage && <ReactMarkdown className="building-footer__message" source={footerMessage} />}
        <StoreApps googlePlay={building.googlePlay} iTunes={building.iTunes}/>

        {
            footerAdvertisement &&
            <Banner className={"advertisement-banner"}>
                <ReactMarkdown source={footerAdvertisement}/>
            </Banner>
        }
    </div>
}
export default BuildingFooter;
